import { MAX_WORD_LENGTH } from '../../constants/settings'
import { EmptyCell } from './EmptyCell'
import { unicodeSplit } from '../../lib/words'

type Props = {
  guess: string
  className: string
}

export var currentCell: number = 0;
export const setCurrentCell = (value:number) => {
   value < MAX_WORD_LENGTH ? value >= 0 ? currentCell = value : currentCell = 0 : value >= 0 ? currentCell = value : currentCell = MAX_WORD_LENGTH
}
export const CurrentRow = ({ guess, className }: Props) => {
  if(guess === '') {
     for(var i = 0; i < MAX_WORD_LENGTH; i++) {
        guess += '_'
     }
  }
  const splitGuess = unicodeSplit(guess)
  const classes = `flex justify-center mb-1 ${className}`
  const onClick = (value: number) => {
   value < MAX_WORD_LENGTH ? value >= 0 ? currentCell = value : currentCell = 0 : value >= 0 ? currentCell = value : currentCell = MAX_WORD_LENGTH
   }

  return (
    <div className={classes}>
      {splitGuess.map((letter, i) => (
        <EmptyCell key={i} position={i} onClick={onClick} value={letter.replace('_', '')} />
      ))}
    </div>
  )
}